'use client';

import type { PropsWithChildren, HTMLAttributes } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

export type CarouselProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

export const CarouselWrapper = ({ children, className, ...props }: CarouselProps) => (
  <div
    className={cn('product-card-grid-wrapper bg-color-grey-light relative p-1', className)}
    {...props}
  >
    {children}
  </div>
);
